import templateUrl from './trip-planner-details.html';
import capitalize from 'lodash/capitalize';
import find from 'lodash/find';
import last from 'lodash/last';

export const tripPlannerDetailsComponent = {
    bindings: {
        directionDetails: '<',
        advanceOptionsDetails: '<',
        onChange: '&',
        onMobileSearchChange: '&',
        onDepartAtChange: '&',
        onGetHelpChange: '&'
    },

    templateUrl,

    controller: class TripPlannerDetailsComponent {
        constructor(GoogleAnalytics, Constants) {
            'ngInject';

            this.googleAnalytics = GoogleAnalytics;
            this.Constants = Constants;
        }

        $onInit() {
            this.originName = this.directionDetails.origin.details.name;
            this.destinationName = this.directionDetails.destination.details.name;
            this.countyName = this._getCountyName();
            this.ageRangeOptions = [{
                id: 1,
                name: "1-17",
                value: 10,
            }, {
                id: 2,
                name: "18-49",
                value: 19
            }, {
                id: 3,
                name: "50-64",
                value: 60
            }, {
                id: 4,
                name: "65+",
                value: 70
            }];
            if (this.advanceOptionsDetails.age) {
                this._updateParticularAgeSearchInGoogleAnalytics(this.advanceOptionsDetails.age, 'ageRange');
                this._updateCountyLevelAgeSearchInGoogleAnalytics();
            }
        }

        _getSpecialRequirementName(name) {
            return capitalize(name.replace(/_/g, ' '));
        }

        _getAgeTitle(optionId) {
            return optionId ? find(this.ageRangeOptions, ({ id }) => parseInt(optionId) === id) : null;
        }

        _getCountyName() {
            return last(JSON.parse(this.advanceOptionsDetails.originServiceAreas)).placeShortName;
        }

        _updateParticularAgeSearchInGoogleAnalytics(ageId, eventName, countyName = '') {
            const { name: label, value } = this._getAgeTitle(ageId);
            const attributes = {
                eventCategory: `${eventName}Category`,
                eventAction: `${eventName}Action${countyName}`,
                eventLabel: label,
                eventValue: value
            };
            
            this.googleAnalytics.event(eventName, attributes);
        }

        _updateCountyLevelAgeSearchInGoogleAnalytics() {
            if (this._isSearchCountyRegisteredInGoogleAnalytics()) {
                this._updateParticularAgeSearchInGoogleAnalytics(this.advanceOptionsDetails.age, `ageRange`, this.countyName);
            }
        }

        _isSearchCountyRegisteredInGoogleAnalytics() {
            const index = this.Constants.COUNTY_TO_TRACK_FOR_ANALYTICS.indexOf(this.countyName);
            return index !== -1;
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/trip-planner/trip-planner-details/trip-planner-details.component.js